/**
 * Справочник переводов для полей форм и интерфейса
 * Поддерживает несколько языков (по умолчанию русский)
 */

const translations = {
  ru: {
    // Названия полей форм
    fields: {
      // Файловые поля
      image: "Изображение",
      image_input: "Входящее изображение",
      input_image: "Входящее изображение",
      image_urls: "Входящие изображения",
      start_image: "Стартовое изображение",
      end_image: "Конечное изображение",
      last_frame: "Последний кадр",
      last_frame_image: "Изображение последнего кадра",
      reference_images: "Референсные изображения",
      reference_video: "Референсное видео",
      mask: "Маска",
      input_video: "Входящее видео",
      video: "Видео",
      video_url: "Видео для редактирования",

      // Параметры генерации
      prompt: "Описание",
      negative_prompt: "Негативное описание",
      guidance: "Контроль",
      guidance_scale: "Масштаб контроля",
      steps: "Шаги",
      num_inference_steps: "Количество шагов вывода",
      num_outputs: "Количество результатов",

      // Разрешение и формат
      resolution: "Разрешение",
      width: "Ширина",
      height: "Высота",
      aspect_ratio: "Соотношение сторон",
      output_format: "Формат вывода",
      format: "Формат",
      image_format: "Формат изображения",

      // Видео параметры
      duration: "Длительность",
      fps: "Кадров в секунду",
      frames_per_second: "Кадров в секунду",
      mode: "Режим",
      generation_mode: "Режим",

      // Аудио
      generate_audio: "Генерировать аудио",
      audio: "Аудио",

      // Редактирование
      outpaint: "Отдаление",
      inpaint: "Заполнение",
      strength: "Сила",
      denoising_strength: "Сила шумоподавления",
      seed: "Seed",
      random_seed: "Случайный seed",

      // Безопасность и качество
      safety_tolerance: "Допуск безопасности",
      nsfw: "NSFW",
      safety: "Безопасность",
      quality: "Качество",
      background: "Фон",
      scheduler: "Планировщик",

      // Дополнительные параметры
      prompt_upsampling: "Улучшение промпта",
      upscale: "Увеличение",
      scale: "Масштаб",
      megapixels: "Мегапиксели",
      model: "Модель",
      version: "Версия",
      temperature: "Температура",
      top_p: "Top P",
      top_k: "Top K",
      max_tokens: "Максимум токенов",
      num_beams: "Количество лучей",
      repetition_penalty: "Штраф за повторение",

      // Специфичные для моделей
      controlnet_conditioning_scale: "Масштаб условия ControlNet",
      controlnet_model: "Модель ControlNet",
      control_mode: "Режим управления",
      conditioning_scale: "Масштаб условия",

      // Дополнительные
      batch_size: "Размер пакета",
      num_images: "Количество изображений",
      samples: "Образцы",
      iterations: "Итерации",
      cfg_scale: "Масштаб CFG",
      eta: "Eta",
      clip_guidance_scale: "Масштаб CLIP управления",
      aesthetic_score: "Эстетический балл",
      negative_aesthetic_score: "Негативный эстетический балл",
    },

    // Значения опций
    options: {
      aspect_ratio: {
        match_input_image: "Как у исходного изображения",
        auto: "Автоматически",
        "21:9": "21:9",
        "16:9": "16:9",
        "16:10": "Широкоэкранный",
        "10:16": "Вертикальный",
        "9:16": "9:16",
        "5:4": "Для печати",
        "4:5": "Вертикальный для ленты",
        "4:3": "4:3",
        "3:4": "3:4",
        "3:2": "3:2",
        "2:3": "2:3",
        "1:1": "1:1",
        "square": "Квадрат",
        "portrait": "Вертикальный",
        "landscape": "Горизонтальный",
      },
      safety_filter_level: {
        block_low_and_above: "Строгий (блокирует низкий и выше)",
        block_medium_and_above: "Средний (блокирует средний и выше)",
        block_only_high: "Разрешающий (блокирует только высокий)",
      },
      resolution: {
        "1K": "1K (1024px)",
        "2K": "2K (2048px)",
        "4K": "4K (4096px)",
      },
      output_format: {
        jpg: "JPG",
        jpeg: "JPEG",
        png: "PNG",
        webp: "WEBP",
      },
      mode: {
        standard: "Стандарт",
        std: "Стандарт",
        pro: "Профессиональный",
      },
      tier: {
        standard: "720p",
        pro: "1080p",
      },
      generation_mode: {
        "text-to-video": "Текст в видео",
        "image-to-video": "Изображение в видео",
        "reference-to-video": "Референсы в видео",
        "video-edit": "Редактирование видео",
        "fast/text-to-video": "Fast: текст в видео",
        "fast/image-to-video": "Fast: изображение в видео",
        "fast/reference-to-video": "Fast: референсы в видео",
        "generate": "Генерация",
        "edit": "Редактирование",
        "flare": "Flare — быстрее",
        "sunburst": "Sunburst — детальнее",
      },
      quality: {
        "low": "Низкое",
        "medium": "Среднее",
        "high": "Высокое",
        "xhigh": "Очень высокое",
        "max": "Максимум",
        "auto": "Авто",
      },
      image_size: {
        "1K": "1K",
        "auto_1K": "Авто 1K (до 2,36 МП)",
        "auto_2K": "Авто 2K (до 4,19 МП)",
        "portrait_16_9": "Портрет 9:16",
        "square_hd": "Квадрат HD (1024×1024)",
        "square": "Квадрат (512×512)",
        "portrait_4_3": "Портрет 4:3",
        "landscape_4_3": "Пейзаж 4:3",
        "landscape_16_9": "Пейзаж 16:9",
        "2K": "2K",
        "4K": "4K",
        "auto": "Авто (по изображению)",
      },
      background: {
        auto: "Авто",
        transparent: "Прозрачный",
        opaque: "Непрозрачный",
      },
    },

    // Общие сообщения
    common: {
      min_value: "Минимальное значение",
      max_value: "Максимальное значение",
      required_field: "Обязательное поле",
      upload_image: "Нажмите или перетащите изображение",
      upload_images: "Нажмите или перетащите изображения",
      upload_video: "Нажмите или перетащите видео",
      upload_audio: "Нажмите или перетащите аудио",
      max_files: "До {count} изображений, макс. 10MB каждое",
      max_videos: "До {count} видео, макс. {size}MB каждое",
      max_audios: "До {count} аудио, макс. {size}MB каждое",
      single_file: "Одно изображение, макс. 10MB",
      single_video: "Одно видео, макс. {size}MB",
      single_audio: "Одно аудио, макс. {size}MB",
    },
  },

  en: {
    // Field names
    fields: {
      image: "Image",
      image_input: "Input Image",
      input_image: "Input Image",
      image_urls: "Input Images",
      start_image: "Start Image",
      end_image: "End Image",
      last_frame: "Last Frame",
      last_frame_image: "Last Frame Image",
      reference_images: "Reference Images",
      mask: "Mask",
      input_video: "Input Video",
      video: "Video",

      prompt: "Description",
      negative_prompt: "Negative Description",
      guidance: "Guidance",
      guidance_scale: "Guidance Scale",
      steps: "Steps",
      num_inference_steps: "Number of Inference Steps",
      num_outputs: "Number of Outputs",

      resolution: "Resolution",
      width: "Width",
      height: "Height",
      aspect_ratio: "Aspect Ratio",
      output_format: "Output Format",
      format: "Format",
      image_format: "Image Format",

      duration: "Duration",
      fps: "Frames Per Second",
      frames_per_second: "Frames Per Second",
      mode: "Mode",
      generation_mode: "Mode",

      generate_audio: "Generate Audio",
      audio: "Audio",

      outpaint: "Outpaint",
      inpaint: "Inpaint",
      strength: "Strength",
      denoising_strength: "Denoising Strength",
      seed: "Seed",
      random_seed: "Random Seed",

      safety_tolerance: "Safety Tolerance",
      nsfw: "NSFW",
      safety: "Safety",
      quality: "Quality",
      background: "Background",
      scheduler: "Scheduler",

      prompt_upsampling: "Prompt Upsampling",
      upscale: "Upscale",
      scale: "Scale",
      megapixels: "Megapixels",
      model: "Model",
      version: "Version",
      temperature: "Temperature",
      top_p: "Top P",
      top_k: "Top K",
      max_tokens: "Max Tokens",
      num_beams: "Number of Beams",
      repetition_penalty: "Repetition Penalty",

      controlnet_conditioning_scale: "ControlNet Conditioning Scale",
      controlnet_model: "ControlNet Model",
      control_mode: "Control Mode",
      conditioning_scale: "Conditioning Scale",

      batch_size: "Batch Size",
      num_images: "Number of Images",
      samples: "Samples",
      iterations: "Iterations",
      cfg_scale: "CFG Scale",
      eta: "Eta",
      clip_guidance_scale: "CLIP Guidance Scale",
      aesthetic_score: "Aesthetic Score",
      negative_aesthetic_score: "Negative Aesthetic Score",
    },

    options: {
      aspect_ratio: {
        match_input_image: "Match Input Image",
        auto: "Auto",
        "21:9": "21:9",
        "16:9": "16:9",
        "16:10": "Widescreen",
        "10:16": "Vertical",
        "9:16": "9:16",
        "5:4": "Print",
        "4:5": "Feed (Portrait)",
        "4:3": "4:3",
        "3:4": "3:4",
        "3:2": "3:2",
        "2:3": "2:3",
        "1:1": "1:1",
        "square": "Square",
        "portrait": "Portrait",
        "landscape": "Landscape",
      },
      safety_filter_level: {
        block_low_and_above: "Strict (blocks low and above)",
        block_medium_and_above: "Medium (blocks medium and above)",
        block_only_high: "Permissive (blocks only high)",
      },
      resolution: {
        "1K": "1K (1024px)",
        "2K": "2K (2048px)",
        "4K": "4K (4096px)",
      },
      output_format: {
        jpg: "JPG",
        jpeg: "JPEG",
        png: "PNG",
        webp: "WEBP",
      },
      mode: {
        standard: "Standard",
        pro: "Professional",
      },
      tier: {
        standard: "720p",
        pro: "1080p",
      },
      generation_mode: {
        "text-to-video": "Text to video",
        "image-to-video": "Image to video",
        "reference-to-video": "Reference to video",
        "video-edit": "Edit video",
        "fast/text-to-video": "Fast: text to video",
        "fast/image-to-video": "Fast: image to video",
        "fast/reference-to-video": "Fast: reference to video",
        "generate": "Generate",
        "edit": "Edit",
        "flare": "Flare — faster",
        "sunburst": "Sunburst — more detail",
      },
      quality: {
        "low": "Low",
        "medium": "Medium",
        "high": "High",
        "xhigh": "Extra high",
        "max": "Max",
        "auto": "Auto",
      },
      image_size: {
        "1K": "1K",
        "auto_1K": "Auto 1K (up to 2.36 MP)",
        "auto_2K": "Auto 2K (up to 4.19 MP)",
        "square_hd": "Square HD (1024×1024)",
        "square": "Square (512×512)",
        "portrait_4_3": "Portrait 4:3",
        "portrait_16_9": "Portrait 9:16",
        "landscape_4_3": "Landscape 4:3",
        "landscape_16_9": "Landscape 16:9",
        "2K": "2K",
        "4K": "4K",
        "auto": "Auto (from image)",
      },
      background: {
        auto: "Auto",
        transparent: "Transparent",
        opaque: "Opaque",
      },
    },

    common: {
      min_value: "Minimum value",
      max_value: "Maximum value",
      required_field: "Required field",
      upload_image: "Click or drag image",
      upload_images: "Click or drag images",
      upload_video: "Click or drag video",
      upload_audio: "Click or drag audio",
      max_files: "Up to {count} images, max 10MB each",
      max_videos: "Up to {count} videos, max {size}MB each",
      max_audios: "Up to {count} audio files, max {size}MB each",
      single_file: "One image, max 10MB",
      single_video: "One video, max {size}MB",
      single_audio: "One audio, max {size}MB",
    },
  },
};

/**
 * Получить перевод для названия поля
 * @param {string} fieldName - Название поля (например, "image_input")
 * @param {string} language - Язык (по умолчанию "ru")
 * @param {string} fallback - Резервное значение, если перевод не найден
 * @returns {string} Переведенное название
 */
export function translateFieldName(fieldName, language = 'ru', fallback = null) {
  if (!fieldName) return fallback || '';

  const lang = translations[language] || translations.ru;
  const translated = lang.fields[fieldName.toLowerCase()];

  if (translated) {
    return translated;
  }

  // Если перевода нет, возвращаем fallback или форматируем название
  if (fallback !== null) {
    return fallback;
  }

  // Автоматическое форматирование: image_input -> Image Input
  const words = fieldName.replace(/_/g, ' ').replace(/-/g, ' ').split(' ');
  return words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
}

/**
 * Проверить, есть ли перевод для поля в справочнике
 * @param {string} fieldName - Название поля
 * @param {string} language - Язык (по умолчанию "ru")
 * @returns {boolean} true если перевод есть в справочнике
 */
export function hasTranslation(fieldName, language = 'ru') {
  if (!fieldName) return false;
  const lang = translations[language] || translations.ru;
  return !!lang.fields[fieldName.toLowerCase()];
}

/**
 * Получить перевод для значения опции
 * @param {string} fieldName - Название поля
 * @param {string} optionValue - Значение опции
 * @param {string} language - Язык (по умолчанию "ru")
 * @returns {string} Переведенное значение или оригинал
 */
export function translateOptionValue(fieldName, optionValue, language = 'ru') {
  if (!fieldName || !optionValue) return optionValue;

  const lang = translations[language] || translations.ru;
  const fieldOptions = lang.options[fieldName.toLowerCase()];

  if (fieldOptions && fieldOptions[optionValue]) {
    return fieldOptions[optionValue];
  }

  // Возвращаем оригинальное значение, если перевода нет
  return optionValue;
}

/**
 * Получить общий перевод
 * @param {string} key - Ключ перевода (например, "min_value")
 * @param {string} language - Язык (по умолчанию "ru")
 * @param {object} params - Параметры для подстановки (например, {count: 5})
 * @returns {string} Переведенный текст
 */
export function translateCommon(key, language = 'ru', params = {}) {
  const lang = translations[language] || translations.ru;
  let text = lang.common[key] || key;

  // Подстановка параметров (например, {count} -> 5)
  if (params) {
    Object.keys(params).forEach(param => {
      text = text.replace(`{${param}}`, params[param]);
    });
  }

  return text;
}

/**
 * Получить все переводы для языка
 * @param {string} language - Язык (по умолчанию "ru")
 * @returns {object} Объект с переводами
 */
export function getTranslations(language = 'ru') {
  return translations[language] || translations.ru;
}

export default translations;

